import i18next from 'i18next';

i18next.addResources('es', 'search', {
  linkText: 'Limpiar búsqueda',
  itemsFound: 'Hemos encontrado {{count}} resultado',
  withoutResult: 'No hemos encontrado resultados',
  itemsFound_plural: 'Hemos encontrado {{count}} resultados' // eslint-disable-line camelcase
});
